import axios from 'axios';
import { API_BASE } from './apiConfig';

export const ApiCall = requestInfo => {
  return axios({ ...requestInfo, url: API_BASE });
};
